/* global squiz */

/**
 *
 * @desc Showing or hiding load spinner
 * @param action {string}
 * - "show"
 * - "hide"
 */

export const loadSpiner = (action) => {
    const body = document.querySelector('body');
    action === 'show'
        ? body.classList.add('loading')
        : body.classList.remove('loading');
};

// export const loadSpiner = (action) => {
//     const body = document.querySelector('body');
//     const lottieLoader = document.createElement('div');
//     lottieLoader.classList.add('lottie-loader__body');
//     lottieLoader.innerHTML = '<lottie-player src="./?a=197380" background="transparent" speed="1" style="width: 80px; height: 80px;" loop="" autoplay=""></lottie-player>';

//     if (action === 'show') {
//         body.classList.add('loading');
//         body.append(lottieLoader);
//     } else {
//         body.classList.remove('loading');
//         body.querySelector('.lottie-loader__body').remove();
//     }
// };

/**
 *
 * @desc Showing or hiding lightBox and clea
 * @param action {string}
 * example:
 * - "show"
 * - "hide"
 */

export const lightboxActions = (action) => {
    const lightbox = document.querySelector('.lightbox-section');
    if(action === 'show') {
        lightbox.classList.add('visible');
    } else {
        lightbox.classList.remove('visible');
        squiz.fn.lightboxClean();
    }
};

/**
 * @desc Removing childrens from '.lightbox__content'
 */
export const lightboxClean = () => {
    [...document.querySelector('.lightbox__content').children].map(el => el.parentNode.removeChild(el));
    // hide submit when lightbox is reseted
    document.querySelector('.lightbox__button--send').classList.add('hidden');
};


/**
 * @desc support for subscribe button
 */
export const subscribeButton = () => {
    var subscribeSubmit = document.querySelector('#subscribe-submit');
    var subscribeUrls = [...document.querySelectorAll('input[data-form-url]')];
    if(subscribeSubmit && subscribeUrls.length) {
        var checkedOnStart = document.querySelector('input[data-form-url]:checked');
        if(checkedOnStart) {
            const url = checkedOnStart.getAttribute('data-form-url');
            subscribeSubmit.setAttribute('data-lightbox-ajax-site', url);
        }

        [...document.querySelectorAll('input[data-form-url]')].map(el => {
            el.addEventListener('click', function (e) {
                subscribeSubmit.classList.remove('btn--disable');
                var url = e.currentTarget.getAttribute('data-form-url');
                subscribeSubmit.setAttribute('data-lightbox-ajax-site', url);
            });
        });

        subscribeSubmit.addEventListener('click', function (e) {
            e.preventDefault();
        });
    }
};

/**
 * @desc add or remove class for carousel 3 items on resize
 */
export const carouselCheck = () => {
    const carousels = document.querySelectorAll('.glide[data-glide-story-carousel-id]');
    if (carousels) {
        Array.from(carousels).forEach((storyCarousel) => {
            if (window.innerWidth >= squiz.vars.desktopWidthMid) {
                storyCarousel.querySelector('.glide__track').classList.remove('carousel-destroyed');
            } else {
                storyCarousel.querySelector('.glide__track').classList.add('carousel-destroyed');
            }
        })
    }
};

/**
 * @desc proper alignment of bottom link when content centered on mobile devices
 */ 

 export const mobileElementsAlign = () => {
    const columnsCentered = document.querySelectorAll('.col-mobile-centered');
    const contentCentered = document.querySelectorAll('.content-mobile-centered');
    if (columnsCentered) {
        Array.from(columnsCentered).forEach(columns => {
            const bottomLink = columns.querySelector('.link-mobile-centered');
            if (bottomLink) {
                bottomLink.classList.add("col-mobile-link");
                columns.classList.add("col-mobile-centered-pb")
            }
        })
    }
    if (contentCentered) {
        Array.from(contentCentered).forEach(content => {
            const staticSizeThree = content.querySelector('.static-size-3');
            const staticSizeFour = content.querySelector('.static-size-4');
            if (staticSizeFour && staticSizeFour.parentNode.classList.contains('content-mobile-centered')) {
                staticSizeFour.parentNode.classList.add('col-mobile-centered');
            }
            if (staticSizeThree && staticSizeThree.parentNode.classList.contains('content-mobile-centered')) {
                staticSizeThree.parentNode.classList.add('col-4-mobile-centered');
            }
        })
    }
};
/** 
 * @desc Disable corresponding search pagination buttons if they're present on edge pages
 */
export const disableEdgeButtonsObserverSetup = () => {
    const targetNode = document.querySelector('.results-wrapper') || null;
    if(targetNode){
    const config = {
        subtree:true,
        childList:true,
    }
    const disableEdgeBtns = () => {
        const btnNext = document.querySelector('.btn--listing-next');
        const btnPrev = document.querySelector('.btn--listing-previous');
        if(btnNext && btnNext.getAttribute('data-startrank') === 'null'){
            btnNext.setAttribute('disabled',true);
        }
        if(btnPrev && btnPrev.getAttribute('data-startrank') === 'null'){
            btnPrev.setAttribute("disabled", true);
        }
    }
    const observer = new MutationObserver(disableEdgeBtns);
    observer.observe(targetNode,config);
}
}